export interface LicenseActivationClass{
    MachineId: string
    ActivationMachineKey: string
    ActivationType:string
    ActivationLicenseKey:string
    LicenseId:string
    PackageCode:string
    AccountId: number
    isSelected:number
}


const common = {    
    MachineId: "",
    ActivationMachineKey:"",
    ActivationType:"Online Activation",
    ActivationLicenseKey:"",
    LicenseId:"",
    PackageCode:"1"
  };
  
  export const licenseActivationInitialsForAdd = { ...common };
  
  export const licenseActivationInitialsForUpdate = {
    ...common,
  };
  